export function formatMemoryDate(value) {
  if (value == null) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return [
    date.getDate(),
    date.toLocaleString("en-US", { month: "short" }),
    date.getFullYear(),
  ].join(" ");
}
